import React from 'react';
import PropTypes from 'prop-types';
import './HeadingMedium.css';

/**
 * HeadingMedium — Configurator
 *
 * Mid-size section heading with optional price on the right.
 * Layout:  Title (H3)                                    +159,-
 *
 * Figma node: 3911:14678
 * Toggle props: showPrice
 */

const HeadingMedium = ({
  title = 'Title',
  price,
  titleVariant = 'h3',
  className = '',
  ...props
}) => {
  const Title = titleVariant === 'h2' ? 'h2' : 'h3';
  return (
    <div className={`cfg-heading-md ${className}`.trim()} {...props}>
      <Title className={`cfg-heading-md__title typo-${Title}`}>{title}</Title>

      {price && (
        <span className="cfg-heading-md__price typo-body">{price}</span>
      )}
    </div>
  );
};

HeadingMedium.propTypes = {
  /** Heading title text */
  title: PropTypes.string,
  /** Price text (e.g. "+159,-") */
  price: PropTypes.string,
  /** Title size: 'h3' (default, Figma) or 'h2' — e.g. a section that opens the column */
  titleVariant: PropTypes.oneOf(['h2', 'h3']),
  /** Additional CSS class */
  className: PropTypes.string,
};

export default HeadingMedium;
